import {AnyAction, combineReducers} from "redux";
import {START_DRAGGING, STOP_DRAGGING} from "../actions/action";

export const isDragging = state => state.interaction.dragging;


/**
 * set dragging state
 * @param state
 * @param action
 * @return {any}
 */
function dragging(state: boolean = false, action: AnyAction) : boolean
{
    switch (action.type)
    {
        case START_DRAGGING:
        {
            return true;
        }

        case STOP_DRAGGING:
        {
            return false;
        }

        default:

            return state;
    }
}


export const interaction = combineReducers({
    dragging
});


// WEBPACK FOOTER //
// ./src/ts/store/reducers/interaction.ts